import type { Distance, Point } from "@pdfking/math"
import { Mean } from "@pdfking/math"

import type { FolderPath } from "#public"

import { FolderLine } from "./FolderLine"
import { FolderSame } from "./FolderSame"

type Segment = [Point<Distance>, Point<Distance>]

/** The folds on each side of a gusset or a spine, `inner` and `outer`: one
 * when it has no thickness, and with `middle` a third halfway between. */
export const FolderCreases = ([a, b]: Segment, [c, d]: Segment, middle = false): FolderPath[] => {
  if (FolderSame(a, c) && FolderSame(b, d)) return [FolderLine(a, b)]
  const half = (p: Point<Distance>, q: Point<Distance>) => ({
    x: Mean(p.x, q.x),
    y: Mean(p.y, q.y),
  })
  return [
    FolderLine(a, b),
    ...(middle ? [FolderLine(half(a, c), half(b, d))] : []),
    FolderLine(c, d),
  ]
}
